import { Component, Input } from '@angular/core';
import { StatusKind, statusBadgeClass, statusLabel } from './status-styles';

/** <lb-status-badge kind="order" [status]="order.currentStatus"></lb-status-badge> */
@Component({
  selector: 'lb-status-badge',
  template: `<span class="lb-status-badge" [ngClass]="badgeClass ? cssClass + ' ' + badgeClass : cssClass">{{ label || text }}</span>`
})
export class LbStatusBadgeComponent {
  @Input() kind: StatusKind = 'order';
  @Input() status: string | null | undefined = '';
  /** Overrides the displayed text (the colour still follows status) */
  @Input() label = '';
  /** Extra classes for the badge, e.g. "fs-6" */
  @Input() badgeClass = '';

  get cssClass(): string {
    return statusBadgeClass(this.kind, this.status);
  }

  get text(): string {
    return statusLabel(this.status);
  }
}
